<!-- <footer role="contentinfo" id="footer">   -->
  <footer aria-label="content info">
    <div *ngIf="show">
      <ul class="first">
        <li><a href="#" title="..." aria-label="contatti">Contatti</a></li>
        <li><a href="#" title="..." aria-label="richiedi assistenza">Richiedi assistenza</a></li>
        <li><a href="#" title="..." aria-label="privacy">Privacy</a></li>
      </ul>
      <ul>
        <li><a href="#" title="..." aria-label="copyright">COPYRIGHT</a></li>
        <li><a href="https://www.euforlegal.it/" title="Visita EUforLEGAL" aria-label="euforlegal">EUforLEGAL</a></li>
        <li><a href="#" title="..." aria-label="policy privacy">Policy Privacy</a></li>
        <li><a href="#" title="..." aria-label="terms of service">Terms of Service</a></li>
      </ul>
    </div>
  </footer>
<!-- </footer> -->
